class CertificateShowcaseSwiper extends HTMLElement {
    connectedCallback() {
        const _this = this;
        function init() {
            const container = _this.querySelector('.certificateShowcase__swiper');
            if (!container) return;

            // 避免重复初始化
            if (container.swiper) container.swiper.destroy(true, true);

            const wrapper = container.querySelector('.swiper-wrapper');
            if (!wrapper) return;

            // 1) 清理之前的克隆（避免重复克隆）
            wrapper.querySelectorAll('.swiper-slide[data-dup="true"]').forEach(n => n.remove());

            // 2) 获取“原始”slide（不含之前克隆的）
            const originalSlides = Array.from(wrapper.children).filter(
            el => el.classList.contains('swiper-slide') && !el.hasAttribute('data-dup')
            );        
            const frag = document.createDocumentFragment();
            originalSlides.forEach(el => {
                const clone = el.cloneNode(true);
                clone.setAttribute('data-dup', 'true'); // 标记为克隆
                frag.appendChild(clone);
            });
            wrapper.appendChild(frag);

            new Swiper(container, {
                loop: true,
                speed: 8000,                        // 越大越慢的“匀速”
                autoplay: {
                  delay: 0,                         // 连续滚
                  disableOnInteraction: false,      // 手动滑后继续
                  stopOnLastSlide: false,           // 非 loop 场景防止停住；loop 下忽略
                  pauseOnMouseEnter: true           // 需要可保留
                },
    
                watchOverflow: false,
                navigation: {
                    nextEl: _this.querySelector('.swiper-button-next'),
                    prevEl: _this.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    0: { slidesPerView: 2, spaceBetween: 12 },
                    640: { slidesPerView: 2, spaceBetween: 16 },
                    1024: { slidesPerView: 3, spaceBetween: 20 },
                    1920: { slidesPerView: 3, spaceBetween: 20 }
                },
                pagination: {
                    el: '.certificateShowcase__swiper .swiper-pagination',
                    clickable: true,         // 允许点击跳转
                    type: 'bullets'          // 默认就是 bullets
                }
            });
        }

        // 首次与编辑器热加载
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
        document.addEventListener('shopify:section:load', function (e) {
            if (e && e.detail && e.detail.sectionId === SID) init();
        });
    }
}


// 注册自定义元素
reg("certificate-showcase-swiper", CertificateShowcaseSwiper);